import { c as _c } from "react/compiler-runtime";
import { ComponentType } from 'react';
import { translate } from '@openclassrooms/translations';
interface Props {
  content: string;
  component?: ComponentType | keyof JSX.IntrinsicElements;
  unsafe?: boolean;
  count?: number;
  with?: {
    [key: string]: string | number;
  };
  className?: string;
}
const Translate = t0 => {
  const $ = _c(21);
  let content;
  let count;
  let otherProps;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      content,
      component: t1,
      count,
      unsafe: t2,
      with: t3,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = content;
    $[2] = count;
    $[3] = otherProps;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    content = $[1];
    count = $[2];
    otherProps = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  const Component = t1 === undefined ? "span" : t1;
  const unsafe = t2 === undefined ? false : t2;
  let t4;
  if ($[7] !== t3) {
    t4 = t3 === undefined ? {} : t3;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const vars = t4;
  let t5;
  if ($[9] !== content || $[10] !== count || $[11] !== vars) {
    t5 = translate(content, vars, count);
    $[9] = content;
    $[10] = count;
    $[11] = vars;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const translatedContent = t5;
  if (unsafe) {
    let t6;
    if ($[13] !== translatedContent) {
      t6 = {
        __html: translatedContent
      };
      $[13] = translatedContent;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== Component || $[16] !== otherProps || $[17] !== t6) {
      t7 = <Component {...otherProps} dangerouslySetInnerHTML={t6} />;
      $[15] = Component;
      $[16] = otherProps;
      $[17] = t6;
      $[18] = t7;
    } else {
      t7 = $[18];
    }
    return t7;
  }
  let t6;
  if ($[19] !== translatedContent) {
    t6 = <span>{translatedContent}</span>;
    $[19] = translatedContent;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default Translate;